<template>
  <Head title="Integrations - Data Blend" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <data-blend-aggregations :client="client" :datablend="datablend"></data-blend-aggregations>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  datablend: Object
});
</script>

